/**
 * Communications consent disclosure.
 *
 * Shown at every point where a user submits contact details (email signup form and the
 * Google-path completion modal) and stored verbatim on the user record at that moment —
 * so we can always show exactly which wording a given user agreed to, even if this text
 * changes later. Keep the stored copy and the displayed copy the same string.
 */
export const COMMUNICATIONS_CONSENT_TEXT =
  'By submitting this form, you consent to receive communications from AutoInvent via email, phone call, and SMS/text message regarding our products, services, promotions, and other relevant information. You may opt out at any time. Consent is not a condition of purchase.'

/** Builds the consent record written to users/{uid}. */
export function buildConsentRecord() {
  return {
    granted: true,
    grantedAt: new Date().toISOString(),
    channels: ['email', 'phone', 'sms'],
    text: COMMUNICATIONS_CONSENT_TEXT,
  }
}

/**
 * Loose phone check — counts digits instead of enforcing a format, so international and
 * punctuated numbers ("+44 20 7946 0958", "(555) 123-4567") both pass.
 */
export function isPhoneValid(phone) {
  return (String(phone).match(/\d/g) || []).length >= 10
}
